﻿// ie fixes
import "whatwg-fetch";
import "@babel/polyfill";

// forEach pollyfill
if (typeof NodeList.prototype.forEach !== "function") {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

// Create Element.remove() function if not exist
if (!("remove" in Element.prototype)) {
    Element.prototype.remove = function() {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}

/***** components *****/
import "./dt/menu";
import "./dt/stickyNav";
import Panel from "./dt/interactivePanel";
import CollectionBar from "./dt/collectionBar";
import CollectionModal from "./dt/collectionModal";
import Swatches from "./dt/swatches";
import Selectable from "./dt/selectable";
import carouselInit from "./dt/carousel";
import Collection from "./dt/collection";
import SpinnerButton from "./dt/spinnerButton";
import { Filters } from "./dt/filters";
import { showModal, hideModal, autoShowModal } from "./dt/modal";

import CollectionSlider from "./common/collectionSlider";
import Form from "./common/form";
import sampleOrderCart from "./common/sampleOrderCart";
import checkout from "./common/checkout";
import loadCollectionListeners from "./common/showcasePage";
import { addListeners } from "./common/collectionPage";
import LoadMorePage from "./dt/loadMorePage";

document.addEventListener("DOMContentLoaded", () => {


    window.stagedProducts = new Set();

    // collection
    // Should pass this into each component instead of making it global
    window.collection = new Collection();
    window.collection.load();
    window.collection.updateCount();

    const collection_bar = new CollectionBar();
    
    const swatches = new Swatches({
        collection_bar: collection_bar
    });

    const collection_modal = new CollectionModal({
        collection_bar: collection_bar
    });

    const panel = new Panel({
        panel: document.querySelector(".interactive-panel"),
        collection_bar: collection_bar
    });

    const load_more_more = document.querySelector(".load-more-more");

    if (load_more_more) {
        const load_more = new LoadMorePage(load_more_more);
    }

    let spinner_buttons = [...document.querySelectorAll(".spinner-button")];
    let selectable = [...document.querySelectorAll(".selectable")];

    if (spinner_buttons.length > 0) {
        spinner_buttons.map(el => {
            new SpinnerButton({
                el: el,
                collection: window.collection
            });
        });
    }

    if (selectable.length > 0) {
        selectable.map(s => {
            new Selectable({
                el: s,
                collection_bar: collection_bar,
                swatches: swatches
            });
        });
    }

    // collection page
    const scrollPosition = document.querySelectorAll(".scroll-position");

    if (scrollPosition) {
        scrollPosition.forEach(s => {
            s.addEventListener("click", () => {
                sessionStorage.setItem("scrollP", window.scrollY);
            });
        });
    }

    if (sessionStorage.getItem("scrollP")) {
        window.scrollTo({
            top: sessionStorage.getItem("scrollP")
        });
        sessionStorage.removeItem("scrollP");
    }

    addListeners();
    window.loadCollectionListeners = loadCollectionListeners;
    window.loadCollectionListeners();

    // modal
    window.showModal = showModal;
    window.hideModal = hideModal;
    autoShowModal();

    window.addEventListener("popstate", function(e) {
        autoShowModal();
    });

    // carousel
    const carousels = document.querySelectorAll("[data-carousel]");

    if (carousels) {
        carousels.forEach(carouselInit);
    }

    // product filters
    const filters = [...document.querySelectorAll(".refine-filters")];

    if (filters.length > 0) {
        filters.forEach(filter => {
            new Filters(filter);
        });
    }

    // collection sliders
    if (document.getElementsByClassName("collection-grid")) {
        let collectionGrids = document.getElementsByClassName(
            "collection-grid"
        );
        
        for (let grid of collectionGrids) {
            new CollectionSlider(grid);
        }
    }

    // sample cart
    if (document.querySelector(".SampleOrderCart")) {
        sampleOrderCart();
    }

    // checkout
    if (document.querySelector("#checkout-form")) {
        checkout();
    }

    // form functionality and validation
    const forms = document.querySelectorAll("[data-form-validation]");
    if (forms) {
        for (let form of forms) {
            new Form(form).load();
        }
    }

    // form functionality and validation
    const numberInputs = document.querySelectorAll(".form-number");
    if (numberInputs) {
        numberInputs.forEach(numberInput => {
            let input = numberInput.querySelector('input[type="number"]'),
                btnUp = numberInput.querySelector(".quantity-up"),
                btnDown = numberInput.querySelector(".quantity-down"),
                min = input.min,
                max = input.max,
                newVal;

            btnUp.addEventListener("click", function customEvent(event) {
                input = numberInput.querySelector('input[type="number"]');
                var oldValue = parseInt(input.value);
                if (oldValue >= max) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue + 1;
                }
                input.value = `${newVal}`;

                fetch("/umbraco/surface/cart/savecartitem", {
                    method: "POST",
                    body: JSON.stringify({
                        sku: input.dataset.sku,
                        quantity: newVal
                    }),
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then(res => {
                        return res.json();
                    })
                    .then(res => {
                        const cartCount = [
                            ...document.querySelectorAll(".js-cart-count")
                        ];
                        cartCount.map(cc => {
                            cc.innerHTML = res.TotalCartCount;
                        });
                    });
            });

            btnDown.addEventListener("click", function customEvent() {
                input = numberInput.querySelector('input[type="number"]');
                var oldValue = parseFloat(input.value);
                if (oldValue <= min) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue - 1;
                }
                input.value = `${newVal}`;

                fetch("/umbraco/surface/cart/savecartitem", {
                    method: "POST",
                    body: JSON.stringify({
                        sku: input.dataset.sku,
                        quantity: newVal
                    }),
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then(res => {
                        return res.json();
                    })
                    .then(res => {
                        const cartCount = [
                            ...document.querySelectorAll(".js-cart-count")
                        ];
                        cartCount.map(cc => {
                            cc.innerHTML = res.TotalCartCount;
                        });
                    });
            });
        });
    }

    const profiles = [...document.querySelectorAll(".profiles .grid-list-item")];

    if(profiles.length > 0) {
        profiles.map(p => {
            const selectable = p.querySelector(".selectable");
            if (selectable) {
                selectable.addEventListener('click', () => {
                    if (p.classList.contains("selected")) {
                        p.classList.remove('selected');
                    } else {
                        p.classList.add('selected');
                    }
                })
            }
        });
    }
});
